module.exports = __webpack_public_path__ + "images/p-value1-11.webp";